import { render, staticRenderFns } from "./PlanExpand.vue?vue&type=template&id=055ce6da&scoped=true&"
import script from "./PlanExpand.vue?vue&type=script&lang=js&"
export * from "./PlanExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ce6da",
  null
  
)

export default component.exports